import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../services/api";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import useRoles from '../hooks/useRoles';

const CustomNavbar = ({ isAuthenticated, setIsAuthenticated }) => {
  const [user, setUser] = useState(null); // Состояние для хранения данных пользователя
  const [company, setCompany] = useState(null);
  const navigate = useNavigate();
  const { hasRole } = useRoles();

  const fetchUser = async () => {
    try {
      const res = await api.get("/users/me"); // Эндпоинт для получения данных пользователя
      setUser(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchCompany = async () => {
    try {
      const res = await api.get("/companies/my");
      setCompany(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  // Загрузка данных пользователя при монтировании компонента
  useEffect(() => {
    if (localStorage.getItem("access_token")) {
      fetchUser();
      fetchCompany();
    }
  }, [isAuthenticated]);

  // Обработка выхода
  const handleLogout = () => {
    localStorage.removeItem("access_token"); // Удаляем токен
    setIsAuthenticated(false); // Обновляем состояние авторизации
    navigate("/login"); // Перенаправляем на страницу входа
    window.location.reload();
  };

  return (
    <Navbar bg="light" expand="lg" className="navbar">
      <Container fluid>
        {/* Бренд или логотип (опционально) */}
        <Navbar.Brand as={Link} to="/">
          {company?.name}
        </Navbar.Brand>

        {/* Кнопка "бургер" для мобильных устройств */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        {/* Основное меню */}
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {hasRole('ReadItem') && (
              <Nav.Link as={Link} to="/items">
                Товары
              </Nav.Link>
            )}
            
            {hasRole('BatchCreateItem') && (
              <Nav.Link as={Link} to="/items/import">
                Импорт товаров
              </Nav.Link>
            )}

            {(hasRole('BatchCreateCdr') || hasRole('BatchUpdateCdr')) && (
              <Nav.Link as={Link} to="/cdrfiles/import">
                Импорт макетов
              </Nav.Link>
            )}

            {(hasRole('CreateCategory') || hasRole('UpdateCategory') || hasRole('DeleteCategory')) && (
              <Nav.Link as={Link} to="/categories">
                Категории
              </Nav.Link>
            )}
            
            {(hasRole('CreateMaterial') || hasRole('UpdateMaterial') || hasRole('DeleteMaterial')) && (
              <Nav.Link as={Link} to="/materials">
                Материалы
              </Nav.Link>
            )}
            
            {hasRole('ReadOrders') && (
              <Nav.Link as={Link} to="/orders">
                Заказы
              </Nav.Link>
            )}
              
            {hasRole('ReadLayoutingOrders') && (
              <Nav.Link as={Link} to="/layouting">
                Компоновка
              </Nav.Link>
            )}

            {hasRole('ReadPrintingSheets') && (
              <Nav.Link as={Link} to="/printing">
                Печать
              </Nav.Link>
            )}

            {hasRole('ReadCuttingSheets') && (
              <Nav.Link as={Link} to="/cutting">
                Резка
              </Nav.Link>
            )}
            
            {hasRole('ReadPackagingOrders') && (
              <Nav.Link as={Link} to="/packaging">
                Упаковка
              </Nav.Link>
            )}

            {hasRole('ReadWarehouseItems') && (
              <Nav.Link as={Link} to="/warehouse">
                Склад
              </Nav.Link>
            )}
            
            {hasRole('ReadAllUsers') && (
              <Nav.Link as={Link} to="/users">
                Пользователи
              </Nav.Link>
            )}
            
          </Nav>

          {/* Правая часть навбара: кнопки входа/регистрации или имя пользователя и выход */}
          <Nav>
            {localStorage.getItem("access_token") ? (
              <>
                <Navbar.Text className="me-3">{user?.userName}</Navbar.Text>
                <Button variant="outline-danger" onClick={handleLogout}>
                  Выйти
                </Button>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/login">
                  Войти
                </Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;